import React from "react";
import { toast } from "react-toastify";
import apiAgent from "../../app/api/apiAgent";
import { OMSButtonStyleL } from "../../app/common/common-components/OMSButton";

import QRCode from "qrcode.react";

class TwoFAComponent extends React.Component {
  state = {
    TwoFAQRCodeValues: {},
    verificationCode: "",
  };

  // ...

  render() {
    const { TwoFASettings, handleTwoFactorChange } = this.props;

    //console.log("inside render, TwoFASettings: ", TwoFASettings);

    const isEnabled = TwoFASettings && TwoFASettings.is_enabled;
    const isConfigured = isEnabled && TwoFASettings.secret_key != null && TwoFASettings.secret_key != "" && TwoFASettings.secret_key != undefined;
    const TwoFAButtonText = isEnabled ? "Disable" : "Enable";

    const twoFAButtonAction = () => {
      // ...

      if (!isEnabled) {
        apiAgent.twoFactorAuth
          .get2FASetupInfo()
          .then((response) => {
            // ...

            this.setState({ TwoFAQRCodeValues: response });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        handleTwoFactorChange("secret_key", "");
        toast.info("Press Save to disable Two Factor Authentication.");
      }
      handleTwoFactorChange("is_enabled", !isEnabled);
    };

    const handleVerificationCodeChange = (event) => {
      this.setState({ verificationCode: event.target.value });
    };

    const verifyCode = () => {
      if(this.state.verificationCode == ""){
        toast.error("Please enter 6 digit verification/auth code.");
        return;
      }

      let base32Secret = this.state.TwoFAQRCodeValues.secretKeyBase32;
      let verificationCode = this.state.verificationCode;
      apiAgent.twoFactorAuth
        .verify2FACodeInitialSetup(verificationCode, base32Secret)
        .then((response) => {
          if (response) {
            toast.success(response.message);
            handleTwoFactorChange("secret_key", response.secret_key);
          } else {
            toast.error("Two Factor Auth Code verification Failed");
          }
        })
        .catch((error) => {
          toast.error("Two Factor Auth Code verification Failed");
        });
    };

    return (
      <div>
        <div className="form-group">
          <label htmlFor="TwoFactorAuth">Two Factor Authentication</label>
          <br />
          {isConfigured && <label>Configured</label>}

          <OMSButtonStyleL
            type="button"
            ui_icon=""
            ui_type={isEnabled ? "delete" : "create"}
            ui_text={TwoFAButtonText}
            ui_processing_text=""
            processing={false}
            disabled={false}
            onClick={twoFAButtonAction}
          />
        </div>
        {isEnabled && !isConfigured && (
          <>
            <div className="form-group">
              Scan the QR code below with a free authenticator app like{" "}
              <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer">
                Google Authenticator
              </a>
              ,{" "}
              <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener noreferrer">
                Microsoft Authenticator
              </a>
              ,{" "}
              <a href="https://play.google.com/store/apps/details?id=com.authy.authy" target="_blank" rel="noopener noreferrer">
                Authy
              </a>
              , or{" "}
              <a href="https://1password.com/downloads/" target="_blank" rel="noopener noreferrer">
                1Password
              </a>{" "}
              to add an extra layer of protection to your account.
              <div>
                <QRCode value={this.state.TwoFAQRCodeValues.authUrl} size={128} level={"H"} />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="verificationCode">Verify the code from the app:</label>
              <div>
                <input
                  type="text"
                  id="verificationCode"
                  name="verificationCode"
                  value={this.state.verificationCode}
                  className="form-control"
                  onChange={handleVerificationCodeChange}
                  style={{ marginRight: "10px", display: "inline-block", width:'auto' }} // Add right margin for space
                />
                <OMSButtonStyleL
                  type="button"
                  ui_icon=""
                  ui_type={"create"}
                  ui_text="Verify"
                  ui_processing_text=""
                  processing={false}
                  disabled={false}
                  onClick={verifyCode}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default TwoFAComponent;
